import React from "react";
import Layout from "./layout/layout.js";
import { Route, Routes, Navigate } from "react-router-dom";
import { SecureRoutes, PublicRoutes } from "./routes/routes.js";
import AuthMiddleware from "./routes/AuthMiddleware.js";
// import FallbackUIForNonAdmin from "./components/FallbackUIForNonAdmin/FallbackUIForNonAdmin.jsx";
import useAuthenticationHook from "./hook/useAuthenticationHook.js";

const App = () => {
  const { role } = useAuthenticationHook();

  return (
    <div className="App">
      <GetRoutesByRole role={role} />
    </div>
  );
};

const GetRoutesByRole = ({ role }) => {
  const routesByRole = SecureRoutes.filter(({ roles }) => roles.includes(role));
  if (role === "user" || role === "admin") {
    return (
      <Routes>
        {routesByRole.map((route) => (
          <Route
            path={route.path}
            key={route.path}
            element={
              <AuthMiddleware>
                <Layout
                  isSubHeaderVisible={route.isSubHeaderVisible}
                  subHeaderTitle={route.subHeaderTitle}
                  isSearchBarVisible={route.isSearchBarVisible}
                  showBackButton={route.showBackButton}
                >
                  {route.element}
                </Layout>
              </AuthMiddleware>
            }
          />
        ))}
      </Routes>
    );
  }
  // Fallback for unknown roles
  return (
    <Routes>
      {PublicRoutes.map((route, index) => (
        <Route path={route.path} element={route.element} key={index} />
      ))}
      {/* fallback route */}
      <Route path="*" element={<div>Unauthorized or unknown role. Please login.</div>} />
    </Routes>
  );
};

export default App;
